import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HourlyRainData } from "../models/hourly-rain-data";
import { RainGauge } from "../models/rain-gauge";
import { ConfigService } from "../config.service";

@Injectable({
  providedIn: "root",
})
export class RainDataService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  getFourDayHourlyRainData(sensorId: string): Observable<HourlyRainData[]> {
    return this.http.get<HourlyRainData[]>(
      `${this.config.apiBase}/rainfall-samples?page=0&pageSize=96&sensorId=${sensorId}`
    );
  }

  getRainGauges(): Observable<RainGauge[]> {
    return this.http.get<RainGauge[]>(`${this.config.apiBase}/sensors`);
  }
}
